document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        (function (window) {
            const testId = 'AB-027';
            const variantId = 'variant-1';
            const defaultCountTime = 899;
            let timeLeft = getTime().timeLeft;
            let timer;

            runVariant();

            function runVariant() {
                if (window.AB_027) return;

                window.AB_027 = 1;
                addCSS();
                addTimer();
                observerCartDrawer();
                observeVisibility();
                observeCustomOptionImage();
                updateCartPageImages();
                document.body.classList.add(testId);
                console.log(`${testId}: ${variantId}`);
            }

            function addTimer() {
                if (document.getElementById(`${testId}-timer-wrapper`)) return;

                const rmoEl = document.querySelector('#slidecarthq .fixed-protection-shipping-upsell-prod');
                const timerHtml = buildTimer();
                console.log("Timmer ... " + rmoEl);
                if (rmoEl) {
                    rmoEl.insertAdjacentHTML('afterbegin', timerHtml);
                    rmoEl.classList.add(`${testId}-timer-added`);
                    timer = setInterval(countdown, 1000);
                } else {
                    console.warn('Element not found');
                }

                updateCartDrawerImages();
            }

            function buildTimer() {
                return `
                <div id="${testId}-timer-wrapper">
                    <p class="${testId}-copy">offer ends in:</p>
                    <div id="${testId}-timer">${convertTime()}</div>
                </div>`;
            }

            function countdown() {
                if (timeLeft <= 0) { timeLeft = defaultCountTime + 1; }
                timeLeft--;
                saveTime(timeLeft);
                updateTimer();
            }

            function updateTimer() {
                const timerEl = document.getElementById(`${testId}-timer`);
                timerEl && (timerEl.innerHTML = convertTime());
            }

            function saveTime(time) {
                window.localStorage.setItem(testId, JSON.stringify({
                    timeLeft: time,
                    timeStamp: Date.now(),
                }));
            }

            function convertTime() {
                const secs = timeLeft % 60;
                return `<p>${Math.floor(timeLeft / 60)}m ${secs < 10 ? '0' : ''}${secs}s</p>`;
            }

            function getTime() {
                let storedTime = JSON.parse(window.localStorage.getItem(testId));
                let left, stamp;
                if (storedTime && storedTime.timeStamp) {
                    left = storedTime.timeLeft;
                    stamp = storedTime.timeStamp;
                } else {
                    left = defaultCountTime;
                    stamp = 0;
                }
                return { timeLeft: left, timeStamp: stamp };
            }

            function observeVisibility() {
                document.addEventListener('visibilitychange', () => {
                    clearInterval(timer);
                    if (!document.hidden) restartTimer();
                });
            }

            function restartTimer() {
                const savedTimeStamp = getTime().timeStamp;
                const savedTimeLeft = getTime().timeLeft;
                if (!savedTimeStamp || !document.getElementById(`${testId}-timer`)) return;

                const timeDiffSecs = Math.round((Date.now() - savedTimeStamp) / 1000);
                let updatedTimeLeft = savedTimeLeft - timeDiffSecs;
                if (updatedTimeLeft <= 0) updatedTimeLeft = defaultCountTime;

                timeLeft = updatedTimeLeft;
                updateTimer();
                saveTime(timeLeft);
                timeLeft > 0 && (timer = setInterval(countdown, 1000));
            }

            // ✅ DYNAMIC: Tries webp first, then png, jpg, jpeg
            function getImageUrl(key, callback) {
                const extensions = ['webp', 'png', 'jpg', 'jpeg'];
                let found = false;

                extensions.forEach((ext) => {
                    if (found) return;
                    const url = `/cdn/shop/files/${key}.${ext}`;
                    const img = new Image();
                    img.onload = function () {
                        if (!found) {
                            found = true;
                            callback(url);
                        }
                    };
                    img.onerror = function() {};
                    img.src = url;
                });
            }

            function getHandleFromHref(href) {
                const match = (href || '').match(/\/products\/([^?]+)/);
                return match ? match[1] : null;
            }

            // ✅ DYNAMIC: Extract ALL birthstones in order from properties object
            // Works for Birthstone 1, 2, 3, 4... any number
            function extractBirthstonesFromProperties(properties) {
                const birthstones = [];

                // Sort keys to ensure correct order: Birthstone 1, Birthstone 2, Birthstone 3...
                const sortedKeys = Object.keys(properties)
                    .filter(key => /^birthstone\s*\d+$/i.test(key))
                    .sort((a, b) => {
                        const numA = parseInt(a.match(/\d+/)[0]);
                        const numB = parseInt(b.match(/\d+/)[0]);
                        return numA - numB;
                    });

                sortedKeys.forEach(key => {
                    const val = properties[key];
                    if (val && val.trim()) {
                        birthstones.push(val.trim().toLowerCase());
                    }
                });

                return birthstones;
            }

            // ✅ DYNAMIC: Extract ALL birthstones from DOM text
            // Works for any number of birthstones in cart item HTML
            function extractBirthstonesFromText(text) {
                const birthstones = [];
                const matches = [];

                // Find all "Birthstone N: Value" patterns
                const regex = /Birthstone\s*(\d+)\s*:\s*([a-zA-Z]+)/gi;
                let match;

                while ((match = regex.exec(text)) !== null) {
                    matches.push({
                        index: parseInt(match[1]),
                        value: match[2].toLowerCase()
                    });
                }

                // Sort by index and return values
                matches
                    .sort((a, b) => a.index - b.index)
                    .forEach(m => birthstones.push(m.value));

                return birthstones;
            }

            // ✅ DYNAMIC: Build image key from handle + any number of birthstones
            // e.g. handle_january_february or handle_january_february_march
            function buildImageKey(handle, birthstones) {
                if (!handle || !birthstones.length) return null;
                return `${handle}_${birthstones.join('_')}`;
            }

            // ============================================
            // CART DRAWER - uses [data-key] selectors
            // ============================================
            function updateCartDrawerImages() {
                document.querySelectorAll('#slidecarthq .item').forEach(function (item, i) {

                    // ✅ DYNAMIC: Find all birthstone properties in order
                    const birthstones = [];
                    const allProps = item.querySelectorAll('.properties-key-value li');

                    const propMap = {};
                    allProps.forEach(li => {
                        const key = li.getAttribute('data-key') || '';
                        const valEl = li.querySelector('.properties-key-value-value');

                        if (valEl) propMap[key] = valEl.textContent.trim();
                    });

                    var metalType = (propMap['Color'] || '').toLowerCase();

                    // Extract birthstones dynamically sorted by number
                    const birthstoneKeys = Object.keys(propMap)
                        .filter(k => /^birthstone\s*\d+$/i.test(k))
                        .sort((a, b) => {
                            const nA = parseInt(a.match(/\d+/)[0]);
                            const nB = parseInt(b.match(/\d+/)[0]);
                            return nA - nB;
                        });

                    birthstoneKeys.forEach(k => {
                        if (propMap[k]) birthstones.push(propMap[k].toLowerCase());
                    });

                    if (!birthstones.length) {
                        console.log(`Drawer Item ${i}: No birthstones found, skipping`);
                        return;
                    }

                    const href = item.querySelector('.item-image-anchor')?.getAttribute('href') || '';
                    const handle = getHandleFromHref(href);
                    if (!handle) return;

                    var key = buildImageKey(handle, birthstones);

                    if (metalType === 'silver') {
                        key += '_silver';
                    }

                    console.log(key);

                    (function (capturedItem, capturedIndex) {
                        getImageUrl(key, function (url) {
                            console.log(`✅ Drawer Item ${capturedIndex}: ${url}`);
                            const anchorImg = capturedItem.querySelector('.item-image-anchor img');
                            if (anchorImg) anchorImg.src = url;

                            const wrapImg = capturedItem.querySelector('.cart__item--image .image-wrap img');
                            if (wrapImg) wrapImg.src = url;
                        });
                    })(item, i);
                });
            }

            // ============================================
            // CART PAGE - uses [data-hulkapps-line-properties]
            // ============================================
            function updateCartPageImages() {
                if (!document.querySelector('.cart__item:not(.cart__item--headers)')) return;

                document.querySelectorAll('.cart__item:not(.cart__item--headers)').forEach(function (item, i) {
                    const img = item.querySelector('.cart__item--image .image-wrap img');

                    const lineProps = item.querySelector('[data-hulkapps-line-properties]');
                    if (!lineProps) {
                        console.log(`Cart Page Item ${i}: No properties, skipping`);
                        if (img) img.classList.add('ab027-loaded');
                        return;
                    }

                    const text = lineProps.textContent || '';

                    // const metalType = text.toLowerCase().includes('silver') ? 'silver' : '';


                    // ✅ DYNAMIC: Extract all birthstones from text
                    const birthstones = extractBirthstonesFromText(text);

                    if (!birthstones.length) {
                        console.log(`Cart Page Item ${i}: No birthstones found`);
                        if (img) img.classList.add('ab027-loaded');
                        return;
                    }

                    const href = item.querySelector('a.image-wrap, a.cart__product-name')?.getAttribute('href') || '';
                    const handle = getHandleFromHref(href);

                    if (!handle) {
                        console.log(`Cart Page Item ${i}: No handle found`);
                        if (img) img.classList.add('ab027-loaded');
                        return;
                    }

                    var key = buildImageKey(handle, birthstones);

                    if (metalType === 'silver') {
                        key += '_silver';
                    }

                    console.log(`Cart Page Item ${i}: key → ${key} (${birthstones.length} birthstones)`);

                    (function (capturedItem, capturedIndex) {
                        getImageUrl(key, function (url) {
                            console.log(`✅ Cart Page Item ${capturedIndex}: ${url}`);
                            const itemImg = capturedItem.querySelector('.cart__item--image .image-wrap img');
                            if (itemImg) {
                                itemImg.src = url;
                                itemImg.classList.add('ab027-loaded');
                            }
                        });
                    })(item, i);
                });
            }

            function updateCartImages() {
                updateCartDrawerImages();
                updateCartPageImages();
            }

            function observeCustomOptionImage() {
                const targetImg = document.querySelector('.custom-option-image');
                if (!targetImg) return;

                const observer = new MutationObserver((mutations) => {
                    mutations.forEach(mutation => {
                        if (mutation.attributeName === 'src') {
                            console.log('Birthstone changed, updating images...');
                            updateCartImages();
                        }
                    });
                });

                observer.observe(targetImg, {
                    attributes: true,
                    attributeFilter: ['src']
                });
            }

            function observerCartDrawer() {
                const cartDrawer = document.querySelector('#slidecarthq .slidecarthq');
                if (!cartDrawer) return;

                const config = { attributes: false, childList: true, subtree: true };

                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        const addedNodes = Array.from(mutation.addedNodes).filter(n => n.nodeType === 1);
                        const removedNodes = Array.from(mutation.removedNodes).filter(n => n.nodeType === 1);
                        const itemsContainerAdded = addedNodes.some(n => n.matches('.items'));
                        const itemsUpdated = addedNodes.some(n => n.matches('.item'));
                        const cartCleared = removedNodes.some(n => n.matches('.items'));

                        if (cartCleared) removeTimer();

                        if (itemsContainerAdded || itemsUpdated) {
                            hasRMO(cartDrawer) ? removeTimer() : addTimer();
                            updateCartDrawerImages();
                        }

                        console.log('yes from here');
                    });
                });

                observer.observe(cartDrawer, config);
            }

            function removeTimer() {
                const timerEl = document.getElementById(`${testId}-timer-wrapper`);
                const rmoEl = document.querySelector('#slidecarthq .fixed-protection-shipping-upsell-prod');

                timerEl && timerEl.remove();
                rmoEl && rmoEl.classList.remove(`${testId}-timer-added`);
                clearInterval(timer);
                timeLeft = defaultCountTime;
                window.localStorage.removeItem(testId);
            }

            function checkedToggle() {
                const checked_input = document.querySelector('#slidecarthq .fixed-protection-shipping-upsell-switch input');
                if (checked_input && checked_input.checked) {
                    const timerEl = document.getElementById(`${testId}-timer-wrapper`);
                    const rmoEl = document.querySelector('#slidecarthq .fixed-protection-shipping-upsell-prod');

                    timerEl && timerEl.remove();
                    rmoEl && rmoEl.classList.remove(`${testId}-timer-added`);
                    clearInterval(timer);
                    timeLeft = defaultCountTime;
                    window.localStorage.removeItem(testId);
                }
            }
            checkedToggle();

            function hasRMO(cartDrawer) {
                return cartDrawer.querySelector('.item[data-variant-id="47439648030925"]');
            }

            function addCSS() {
                const html = `<style id="${testId}-css">
                @font-face{font-family:Inter;font-weight:600;font-style:normal;font-display:swap;src:url("https://cdn.shopify.com/s/files/1/0593/3999/7389/files/Inter-SemiBold.woff2?v=1721990919")}
                #AB-027-timer-wrapper{position:absolute;width:100%;height:40px;background-color:#a02447;top:0;left:0;border-radius:16px 16px 0 0;display:flex;align-items:center;justify-content:space-between}
                #AB-027-timer-wrapper .AB-027-copy{font-family:Inter;font-size:12px;font-weight:600;line-height:15px;text-align:left;color:#fff;text-transform:uppercase;margin:0 0 0 12px}
                #AB-027-timer-wrapper #AB-027-timer{height:24px;padding:0 4px;border-radius:24px;background-color:#fff;display:flex;margin:0 12px 0 0;align-items:center;justify-content:center;min-width:68px}
                #AB-027-timer-wrapper #AB-027-timer p{color:#a02447;font-size:14px;line-height:14px;font-weight:700;letter-spacing:.1px}
                .fixed-protection-shipping-upsell-prod.AB-027-timer-added{position:relative;padding-top:52px!important;height:119px!important}
                .cart__item--image img, .item-image-anchor img { opacity: 0; transition: opacity 0.2s ease; }
                .cart__item--image img.ab027-loaded, .item-image-anchor img.ab027-loaded { opacity: 1; }
                </style>`;
                document.head.insertAdjacentHTML('beforeend', html);
            }

        })(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);
    }, 500);
});